const mergeCfg = (cfg1, cfg2) => {
    for (const k in cfg2) {
        if (k in cfg1) {
            continue;
        }
        cfg1[k] = cfg2[k];
    }
    return cfg1;
};

const getReferrerHostNameParams = () => {
    try {
        let currentHostname = location.hostname;
        currentHostname = currentHostname.replace('www.', '');
        return `&refererHostNames=${currentHostname}&refererHostNames=www.${currentHostname}`;
    } catch (e) { }
    return '';
};

/* old
const liveInfoUrl = 'https://widgets.feeddigi.com/api/v1/liveinfo';
const liveTvUrl = 'https://widgets.feeddigi.com/api/v1/livetv';
*/
const liveInfoUrl = 'https://mc-fqax9n49y7.b-cdn.net';
const liveTvUrl = 'https://mc-coqtmllnf8.b-cdn.net';

const digitainDevConfig = (config) => ({
    wsUrl: `${config?.digitain?.staging?.wsUrl ?? config.digitainStagingApiUrl}`,
    wsPath: '/api/digitain-fetcher/v2/live/ws',
    apiURL: `${config?.digitain?.staging?.apiURL ?? config.digitainStagingApiUrl}/api/digitain-fetcher/v2/public`,

    ticketsWsUrl: `${config?.digitain?.staging?.ticketsWsUrl ?? config.digitainStagingApiUrl}`,
    ticketsWsPath: '/api/digitain-tickets/v1/ws',
    ticketsUrl: `${config?.digitain?.staging?.ticketsUrl ?? config.digitainStagingApiUrl}/api/digitain-tickets/v1/player`,
    ticketsPublicUrl: `${config?.digitain?.staging?.ticketsPublicUrl ?? config.digitainStagingApiUrl}/api/digitain-tickets/v1/public`,
    searchUrl: `${config?.digitain?.staging?.searchUrl ?? config.digitainStagingApiUrl}/api/digitain-fetcher/v2/public/search`,

    widgetUrl: `${config.digitainLiveInfoUrl ?? liveInfoUrl}/[MATCHID]?pId=${config.digitainStagingPartnerId}&t=%23FFF&t2=%23FFF&b=%230e5bb3&l=[LANGUAGE]&IsSmall=true`,
    widgetLiveTvUrl: `${config.digitainLiveTvUrl ?? liveTvUrl}/[MATCHID]?pId=${config.digitainStagingPartnerId}` + getReferrerHostNameParams(),
    widgetCheckUrl: `https://sp-spc-api.sportdigi.com/api/v1/b2c/ScoutProvider/GetScoutData?partnerId=${config.digitainStagingPartnerId}&responseTypeId=1&langIsoCode=en&ids=[MATCHID]`,
    betBuilderUrl: `${config?.digitain?.staging?.betBuilderUrl ?? config.digitainStagingApiUrl}/api/digitain-tickets/v1/public/bet-builder`,

    defaultSportId: '1',
    marketCountNsoft: 3,

    statsUrl: `${config?.digitain?.staging?.statsUrl ?? config.digitainStagingApiUrl}/api/stats/v1/public/sports/event`,
    leagueStatsUrl: `${config?.digitain?.staging?.leagueStatsUrl ?? config.digitainStagingApiUrl}/api/stats/v1/public/sports/wc/team`,
});

const digitainMicrosConfig = (config) => ({
    wsUrl: `${config?.digitain?.production?.wsUrl ?? config.digitainProductionApiUrl}`,
    wsPath: '/api/digitain-fetcher/v2/live/ws',
    apiURL: `${config?.digitain?.production?.apiURL ?? config.digitainProductionApiUrl}/api/digitain-fetcher/v2/public`,

    ticketsWsUrl: `${config?.digitain?.production?.ticketsWsUrl ?? config.digitainProductionApiUrl}`,
    ticketsWsPath: '/api/digitain-tickets/v1/ws',
    ticketsUrl: `${config?.digitain?.production?.ticketsUrl ?? config.digitainProductionApiUrl}/api/digitain-tickets/v1/player`,
    ticketsPublicUrl: `${config?.digitain?.production?.ticketsPublicUrl ?? config.digitainProductionApiUrl}/api/digitain-tickets/v1/public`,
    searchUrl: `${config?.digitain?.production?.searchUrl ?? config.digitainProductionApiUrl}/api/digitain-fetcher/v2/public/search`,

    widgetUrl: `${config.digitainLiveInfoUrl ?? liveInfoUrl}/[MATCHID]?pId=${config.digitainProductionPartnerId}&t=%23FFF&t2=%23FFF&b=%230e5bb3&l=[LANGUAGE]&IsSmall=true`,
    widgetLiveTvUrl: `${config.digitainLiveTvUrl ?? liveTvUrl}/[MATCHID]?pId=${config.digitainProductionPartnerId}` + getReferrerHostNameParams(),
    widgetCheckUrl: `https://sp-spc-api.sportdigi.com/api/v1/b2c/ScoutProvider/GetScoutData?partnerId=${config.digitainProductionPartnerId}&responseTypeId=1&langIsoCode=en&ids=[MATCHID]`,
    betBuilderUrl: `${config?.digitain?.production?.betBuilderUrl ?? config.digitainProductionApiUrl}/api/digitain-tickets/v1/public/bet-builder`,

    defaultSportId: '1',
    marketCountNsoft: 3,

    statsUrl: `${config?.digitain?.production?.statsUrl ?? config.digitainProductionApiUrl}/api/stats/v1/public/sports/event`,
    leagueStatsUrl: `${config?.digitain?.production?.leagueStatsUrl ?? config.digitainProductionApiUrl}/api/stats/v1/public/sports/wc/team`,
});

const digitainWinnerFunDevConfig = (config) => ({
    wsUrl: `${config?.digitainWF?.staging?.wsUrl ?? config.digitainStagingApiUrlWF}`,
    wsPath: '/api/digitain-fetcher/v2/live/ws',
    apiURL: `${config?.digitainWF?.staging?.apiURL ?? config.digitainStagingApiUrlWF}/api/digitain-fetcher/v2/public`,

    ticketsWsUrl: `${config?.digitainWF?.staging?.ticketsWsUrl ?? config.digitainStagingApiUrlWF}`,
    ticketsWsPath: '/api/digitain-tickets-wf/v1/ws',
    ticketsUrl: `${config?.digitainWF?.staging?.ticketsUrl ?? config.digitainStagingApiUrlWF}/api/digitain-tickets-wf/v1/player`,
    ticketsPublicUrl: `${config?.digitainWF?.staging?.ticketsPublicUrl ?? config.digitainStagingApiUrlWF}/api/digitain-tickets-wf/v1/public`,
    searchUrl: `${config?.digitainWF?.staging?.searchUrl ?? config.digitainStagingApiUrlWF}/api/digitain-fetcher/v2/public/search`,

    widgetUrl: `${config.digitainLiveInfoUrl ?? liveInfoUrl}/[MATCHID]?pId=${config.digitainStagingPartnerIdWF}&t=%23FFF&t2=%23FFF&b=%230e5bb3&l=[LANGUAGE]&IsSmall=true`,
    widgetLiveTvUrl: `${config.digitainLiveTvUrl ?? liveTvUrl}/[MATCHID]?pId=${config.digitainStagingPartnerIdWF}` + getReferrerHostNameParams(),
    widgetCheckUrl: `https://sp-spc-api.sportdigi.com/api/v1/b2c/ScoutProvider/GetScoutData?partnerId=${config.digitainStagingPartnerIdWF}&responseTypeId=1&langIsoCode=en&ids=[MATCHID]`,
    betBuilderUrl: `${config?.digitainWF?.staging?.betBuilderUrl ?? config.digitainStagingApiUrlWF}/digitain-tickets-wf/public/bet-builder`,

    defaultSportId: '1',
    marketCountNsoft: 3,

    statsUrl: `${config?.digitainWF?.staging?.statsUrl ?? config.digitainStagingApiUrlWF}/api/stats/v1/public/sports/event`,
    leagueStatsUrl: `${config?.digitainWF?.staging?.leagueStatsUrl ?? config.digitainStagingApiUrlWF}/api/stats/v1/public/sports/wc/team`,
});

const digitainWinnerFunMicrosConfig = (config) => ({
    wsUrl: `${config?.digitainWF?.production?.wsUrl ?? config.digitainProductionApiUrlWF}`,
    wsPath: '/api/digitain-fetcher/v2/live/ws',
    apiURL: `${config?.digitainWF?.production?.apiURL ?? config.digitainProductionApiUrlWF}/api/digitain-fetcher/v2/public`,

    ticketsWsUrl: `${config?.digitainWF?.production?.ticketsWsUrl ?? config.digitainProductionApiUrlWF}`,
    ticketsWsPath: '/api/digitain-tickets-wf/v1/ws',
    ticketsUrl: `${config?.digitainWF?.production?.ticketsUrl ?? config.digitainProductionApiUrlWF}/api/digitain-tickets-wf/v1/player`,
    ticketsPublicUrl: `${config?.digitainWF?.production?.ticketsPublicUrl ?? config.digitainProductionApiUrlWF}/api/digitain-tickets-wf/v1/public`,
    searchUrl: `${config?.digitainWF?.production?.searchUrl ?? config.digitainProductionApiUrlWF}/api/digitain-fetcher/v2/public/search`,

    widgetUrl: `${config.digitainLiveInfoUrl ?? liveInfoUrl}/[MATCHID]?pId=${config.digitainProductionPartnerIdWF}&t=%23FFF&t2=%23FFF&b=%230e5bb3&l=[LANGUAGE]&IsSmall=true`,
    widgetLiveTvUrl: `${config.digitainLiveTvUrl ?? liveTvUrl}/[MATCHID]?pId=${config.digitainProductionPartnerIdWF}` + getReferrerHostNameParams(),
    widgetCheckUrl: `https://sp-spc-api.sportdigi.com/api/v1/b2c/ScoutProvider/GetScoutData?partnerId=${config.digitainProductionPartnerIdWF}&responseTypeId=1&langIsoCode=en&ids=[MATCHID]`,
    betBuilderUrl: `${config?.digitainWF?.production?.betBuilderUrl ?? config.digitainProductionApiUrlWF}/api/digitain-tickets-wf/v1/public/bet-builder`,

    defaultSportId: '1',
    marketCountNsoft: 3,

    statsUrl: `${config?.digitainWF?.production?.statsUrl ?? config.digitainProductionApiUrlWF}/api/stats/v1/public/sports/event`,
    leagueStatsUrl: `${config?.digitainWF?.production?.leagueStatsUrl ?? config.digitainProductionApiUrlWF}/api/stats/v1/public/sports/wc/team`,
});

// we need to do it like this because worker doesn't have access to window object
const getGlobalConfig = () => {
    try {
        if (typeof window !== 'undefined' && window.config) {
            return window.config;
        }
    } catch (e) {
    }

    try {
        if (globalThis?.global?.config) {
            return globalThis.global.config;
        }
    } catch (e) {
    }

    return {};
};

let digitainConfig = () => {
    let config = getGlobalConfig();

    if (config.environment === 'staging') {
        return mergeCfg(digitainDevConfig(config), digitainMicrosConfig(config));
    }
    return digitainMicrosConfig(config);
};

let digitainWinnerFunConfig = () => {
    let config = getGlobalConfig();

    if (config.environment === 'staging') {
        return mergeCfg(digitainWinnerFunDevConfig(config), digitainWinnerFunMicrosConfig(config));
    }
    return digitainWinnerFunMicrosConfig(config);
};

export { digitainConfig, digitainWinnerFunConfig };
